var _excluded = ["colors", "componentColors"],
    _excluded2 = ["Form", "FormError", "Input", "Select", "Button", "Heading", "Tabs", "Badge", "Avatar", "Tooltip", "Table", "Link", "Modal"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { extendTheme as chakraExtendTheme, theme as chakraTheme } from '@chakra-ui/react';
import merge from 'lodash/merge';
import { components } from './components';
import { fonts, getBorders, getColorPalettes, getComponentColorOverrides, getComponentsColorsMapping, radii, shadows, textStyles, themeBreakpoints, themeSpaces, zIndices } from './foundations';
import { icons } from './icons';
import { styles } from './styles';
var melioTheme = {
  space: themeSpaces,
  breakpoints: themeBreakpoints,
  fonts,
  radii,
  shadows,
  textStyles,
  icons,
  styles,
  components
}; // reset top level (body) chakra styles

chakraTheme.styles = {};
export var extendTheme = _ref => {
  var {
    colors = {},
    componentColors
  } = _ref,
      theme = _objectWithoutProperties(_ref, _excluded);

  // This here is a duplicated code from the ColorPalettesProvider until we remove Chakra.
  var colorPalettes = getColorPalettes(colors);
  var borders = getBorders(colorPalettes);
  var componentColorsOverrides = getComponentColorOverrides(colorPalettes, {
    components: componentColors
  });
  var componentsColorMapping = getComponentsColorsMapping(colorPalettes);
  componentsColorMapping = merge(componentsColorMapping, componentColorsOverrides);
  return chakraExtendTheme(melioTheme, theme, _objectSpread(_objectSpread({}, chakraTheme), {}, {
    breakpoints: melioTheme.breakpoints,
    colors: merge(chakraTheme.colors, componentsColorMapping),
    borders: merge(chakraTheme.borders, borders),
    zIndices,
    components: cleanChakraComponents()
  }));
}; // Because chakra has hard coded typography specific css attributes (suh as fontSize) inside some if it's components
// We need to override the whole theme for those components and remove the specific css attributes.
// Chakra doesn't provide a way to do this, but the workaround is to cheat it and make it think the base theme
// We provide in `extendTheme` is the complete chakra theme.
// See:
// https://github.com/chakra-ui/chakra-ui/blob/f9f532e54d5ac76233fb9a957999c36373a96c3c/packages/react/src/extend-theme.ts#L81
// https://github.com/chakra-ui/chakra-ui/blob/f9f532e54d5ac76233fb9a957999c36373a96c3c/packages/theme/src/utils.ts#L25-L33

var cleanChakraComponents = () => {
  var _chakraTheme$componen = chakraTheme.components,
      {
    Form,
    FormError,
    Input,
    Select,
    Button,
    Heading,
    Tabs,
    Badge,
    Avatar,
    Tooltip,
    Table,
    Link,
    Modal
  } = _chakraTheme$componen,
      chakraComponents = _objectWithoutProperties(_chakraTheme$componen, _excluded2);

  return _objectSpread(_objectSpread({}, chakraComponents), {}, {
    Form: _objectSpread(_objectSpread({}, Form), {}, {
      baseStyle: _objectSpread(_objectSpread({}, Form.baseStyle), {}, {
        helperText: {}
      })
    }),
    Modal: _objectSpread(_objectSpread({}, Modal), {}, {
      baseStyle: props => _objectSpread(_objectSpread({}, Modal.baseStyle(props)), {}, {
        header: {},
        // this is to remove the default style
        body: {},
        // this is to remove the default style
        footer: {
          display: 'block'
        }
      })
    })
  });
};
//# sourceMappingURL=theme.js.map